import { atom, useAtom } from 'jotai/index';

type SafesBalancesRecord = Record<string, number>;

const safesBalancesAtom = atom<SafesBalancesRecord>({});

export const useSafesBalances = () => {
  const [safesBalances, setSafesBalances] = useAtom(safesBalancesAtom);

  return {
    safesBalances,
    setSafesBalances,
  };
};
